import { ActionTree, GetterTree, MutationTree } from "vuex";
import { State } from "@/typings/store/index";
import { StateDrawer } from "@/typings/store/modules/drawer";

const state: StateDrawer = {
  drawer: true,
  camera: false,
};

const getters: GetterTree<StateDrawer, State> = {
  get(state) {
    return state.drawer;
  },
  getCamera(state) {
    return state.camera;
  },
};

const mutations: MutationTree<StateDrawer> = {
  set(state, data: boolean) {
    state.drawer = data;
  },
  setCamera(state, data: boolean) {
    state.camera = data;
  },
};

const actions: ActionTree<StateDrawer, State> = {
  set(ctx, data: boolean) {
    ctx.commit("set", data);
  },
  setCamera(ctx, data: boolean) {
    ctx.commit("setCamera", data);
  },
};

const drawer = {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};

export default drawer;
